document.addEventListener("DOMContentLoaded", function() {

  

var allText=document.querySelectorAll(`
.title strong,
.product-form__submit span,
.full-unstyled-link,
.related-products__heading,
.product__text,
.product__title h1,
.product__tax, 
.badge,
.collection__description p,
.price-item,
.full-unstyled-link,
body:not(.template-rele) .luna-templates__text p
`,
);



    allText.forEach((content,index)=>{

      content.style.height=content.clientHeight+"px";
    })
  
  
  const init=()=>{
    
allText=document.querySelectorAll(`
.title strong,
.product-form__submit span,
.full-unstyled-link,
.related-products__heading,
.product__text,
.product__title h1,
.product__tax, 
.badge,
.collection__description p,
.price-item,
.full-unstyled-link,
body:not(.template-rele) .luna-templates__text p
`
);

    /*
    .footer-block__heading,
.footer-block__details-content p,
      */

    
    allText.forEach((content,index)=>{

      if(!content.dataset.content){
        var text=content.innerHTML.trim()
        if(text.length>0){

        }
       content.dataset.content=text
        content.dataset.anim_order=index
        content.innerHTML=""
      }
    
    })
  }


var time=0
var nAnim=0
var letter=0


const shuffle=(text,n)=>{
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@(§!)-/%$€=+£#©©©©©";
  var result=""

  for(i=0;i<text.length;i++){

    if(i<n){
      result+=text.charAt(i)
    }
    
   if(i==n){
    result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
  }

  return result;
}



const animate=()=>{

  init()
  time++


  allText.forEach((text,index)=>{

    letter=Math.floor(time/(5))
    var newText=text.dataset.content  
    
    if(letter<newText.length+1){

    }
              text.innerHTML=shuffle(newText,letter) 
 
  })


}

init()
  
  setTimeout(()=>{
    setInterval(()=>{
  animate()
},50)
  },1500)


  
})